export default __webpack_public_path__ + "static/media/settings_icon_gray.bc86dad9.svg";